import { createSlice } from '@reduxjs/toolkit';
import {
  fetchRoadmapItemsThunk,
  createRoadmapItemThunk,
  updateRoadmapItemThunk,
  deleteRoadmapItemThunk,
} from './roadmapActionThunks';

const initialState = {
  items: [],
  loading: { items: false, mutate: false },
  errors: { items: null, mutate: null },
};

const roadmapSlice = createSlice({
  name: 'roadmap',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // === List ===
      .addCase(fetchRoadmapItemsThunk.pending, (state) => {
        state.loading.items = true;
        state.errors.items = null;
      })
      .addCase(fetchRoadmapItemsThunk.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading.items = false;
      })
      .addCase(fetchRoadmapItemsThunk.rejected, (state, action) => {
        state.loading.items = false;
        state.errors.items = action.payload || 'Failed to load roadmap items';
      })

      // === Create ===
      .addCase(createRoadmapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(createRoadmapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items.unshift(action.payload);
      })
      .addCase(createRoadmapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to create roadmap item';
      })

      // === Update ===
      .addCase(updateRoadmapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(updateRoadmapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(updateRoadmapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to update roadmap item';
      })

      // === Delete ===
      .addCase(deleteRoadmapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(deleteRoadmapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items = state.items.filter((i) => i.id !== action.payload);
      })
      .addCase(deleteRoadmapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to delete roadmap item';
      });
  },
});

export default roadmapSlice.reducer;
